export default {
  'passReset.title': 'Password Changed!',
  'passReset.subtitle':
    'Your account password has been changed successfully. Use your new password to log in.',
  'passReset.login': 'Log in Examod',
  'passReset.goDashboard': 'Go to Your Dashboard',
};
